export const comboDefTrainingGroups = {
    collection: 'traininggroups_view_gridCombo',
    select: 'ID, FieldValue',
    top: '500',
    where: '',
    groupby: '',
    orderby: 'FieldValue',
    with0: 'true',
};
  